export default {
      id: "term-plan-usage",
      viewBox: "0 0 32 32",
      url: __webpack_public_path__ + "sprite.svg#term-plan",
      toString: function () {
        return this.url;
      }
    }